module.exports = __webpack_public_path__ + "static/img/img_helpnow_product01.481cac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_helpnow_product01.png
// module id = VxXK
// module chunks = 1